import React from 'react';
import styled from 'styled-components';
import { Section } from 'components/layout/Section';
import { Header } from 'components/header';
import { BodyText } from 'components/typography/bodyText';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import media from 'constants/styles/media';
import { useStaticQuery, graphql } from 'gatsby';
import { HOW_WE_WORK_TILES } from './constants/howWeWorkTiles';
import { Card } from 'components/card';

const SWrapper = styled.div`
    text-align: left;
    align-self: flex-start;
    margin-bottom: 36px;
    max-width: 632px;
`;

const SGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 36px;

    @media (max-width: ${media.tablet}) {
        grid-template-columns: 1fr;
        gap: 24px;
    }
`;

export const HowWeWorkSection = () => {
    const { t } = useTranslation();

    const { icons } = useStaticQuery(graphql`
        query howWeWorkIcons {
            icons: allFile(
                filter: { relativeDirectory: { eq: "how-we-work" } }
                sort: { fields: relativePath, order: ASC }
            ) {
                nodes {
                    id
                    publicURL
                }
            }
        }
    `);

    const iconUrls = (icons?.nodes ?? [])
        .map((node: { publicURL?: string }) => node.publicURL)
        .filter(Boolean) as string[];

    return (
        <Section>
            <SWrapper>
                <Header text={t('how-we-work.header')} />
                <BodyText>{t('how-we-work.description')}</BodyText>
            </SWrapper>
            <SGrid>
                {HOW_WE_WORK_TILES.map((tile) => {
                    const iconSrc = iconUrls[tile.iconIndex];
                    if (!iconSrc) {
                        return null;
                    }

                    return (
                        <Card
                            key={tile.titleKey}
                            iconSrc={iconSrc}
                            mediaSize={48}
                            isTitleUpperCase
                            header={t(tile.titleKey)}
                            description={t(tile.descriptionKey)}
                        />
                    );
                })}
            </SGrid>
        </Section>
    );
};
